export const ERROR_MESSAGE_MAP = {
  notFound: 'Invalid DOL case number. Please check if the number is correct.',
  notAvailable: 'DOL data unavailable temporarily. Please retry later.',
}
